import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Utwórz kampanię powiadomień push',
  sent_title: 'Powiadomienie w kolejce',
  sent_subtitle:
    'Twoje powiadomienie push zostało wysłane do Apple i Google. Potwierdzenia dostarczenia pojawią się za ok. 15 minut.',
  sent_info_banner:
    'Możesz zamknąć to okno. Będziemy automatycznie sprawdzać i aktualizować statystyki dostarczenia kampanii.',
  circles: {
    sent_label: 'Wysłano',
    sent_sub: 'Przesłano do subskrybentów',
    delivered_label: 'Dostarczone',
    delivered_sub: 'Oczekiwanie na Apple i Google',
    delivered_ready_short: 'Gotowe',
    delivered_ready_sub: 'Odśwież, aby zobaczyć najnowsze statystyki',
  },
  scheduled_title: 'Kampania zaplanowana',
  scheduled_body_line_1: 'Twoje powiadomienie push jest zaplanowane na {{when}}.',
  scheduled_body_line_2:
    'Wyślemy je automatycznie o tej porze. Potwierdzenia dostarczenia od Apple i Google są dostępne ok. 15 minut po wysłaniu.',
  recipients_count_one: 'Wysłano do {{count}} subskrybenta.',
  recipients_count_few: 'Wysłano do {{count}} subskrybentów.',
  recipients_count_many: 'Wysłano do {{count}} subskrybentów.',
  recipients_count_other: 'Wysłano do {{count}} subskrybentów.',
  close: 'Zamknij',
  sections: {
    message: 'Wiadomość',
    audience: 'Odbiorcy',
    when: 'Kiedy wysłać',
    review: 'Przegląd',
  },
  stepper: {
    message: 'Wiadomość',
    audience_when: 'Kiedy wysłać',
    review: 'Przegląd',
  },
  blocked_reasons: {
    title_required: 'Dodaj tytuł, aby kontynuować.',
    body_required: 'Dodaj treść wiadomości, aby kontynuować.',
    offer_required: 'Wybierz ofertę, aby kontynuować.',
    promo_code_required: 'Wybierz kod promo, aby kontynuować.',
    send_option_required: 'Wybierz, kiedy wysłać, aby kontynuować.',
    scheduled_at_required: 'Wybierz datę i godzinę, aby kontynuować.',
  },
  fields: {
    title: {
      label: 'Tytuł',
      placeholder: 'Wpisz tytuł powiadomienia',
    },
    body: {
      label: 'Treść wiadomości',
      placeholder: 'Wpisz treść wiadomości',
    },
    audience: {
      label: 'Odbiorcy',
    },
    send_options: {
      label: 'Opcje wysyłki',
    },
    date_and_time: {
      label: 'Data i godzina',
      placeholder: 'Wybierz datę i godzinę',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Wyślij teraz',
    [SendOptions.Schedule]: 'Zaplanuj',
  },
  send_option_cards: {
    now: {
      title: 'Wyślij teraz',
      description: 'Wyślij natychmiast do wszystkich subskrybentów.',
    },
    schedule: {
      title: 'Zaplanuj',
      description: 'Wybierz datę i godzinę w przyszłości.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promocyjny 🚀',
      description: 'Promuj ofertę lub kod promo.',
    },
    informational: {
      title: 'Informacyjny ℹ️',
      description: 'Podziel się nowością lub aktualizacją — bez rabatu.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Wszyscy użytkownicy ({{count}} urządzenie)',
  },
  preview: {
    title: 'Podgląd',
    notifications: {
      title: 'Tutaj pojawi się tytuł Twojego powiadomienia',
      body: 'Tutaj zostanie wyświetlona treść Twojej wiadomości ze wszystkimi szczegółami...',
      now: 'Teraz',
    },
    estimated_reach: 'Zasięg',
  },
  summary: {
    title: 'Podsumowanie',
    reach: 'Zasięg',
    when: 'Kiedy',
    campaign_type: 'Typ kampanii',
    promo_code: 'Kod promo',
    offer: 'Oferta',
    test_audience: 'Najpierw wyślij testowe powiadomienie push',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Osiągnięto dzienny limit wysyłki',
      description:
        'Hej! Wysyłanie więcej niż 1 powiadomienia push dziennie sprawia, że użytkownicy są niezadowoleni i może prowadzić do usunięcia aplikacji. Dlatego ograniczamy ręczne powiadomienia do 1/dzień. Zaplanuj to na jutro.',
    },
    offer_not_sendable: {
      title: 'Oferta nie obowiązuje dzisiaj',
      description: 'Wybierz datę w przyszłości.',
    },
  },
  buttons: {
    send_now: 'Wyślij teraz',
    save: 'Zapisz',
    save_as_draft: 'Zapisz jako szkic',
    send_test: 'Wyślij test',
    draft_with_ai: 'Utwórz szkic z AI',
    back: 'Wstecz',
    next: 'Dalej',
  },
  feedback: {
    success: 'Kampania zapisana pomyślnie',
    promo_code_expired: 'Kod promo wygasł',
    error: 'Nie udało się zapisać kampanii. Sprawdź połączenie i spróbuj ponownie.',
  },
};
